import { render, staticRenderFns } from "./KeyFinanceRatioPdf.vue?vue&type=template&id=2aff87ff&scoped=true"
import script from "./KeyFinanceRatioPdf.vue?vue&type=script&lang=js"
export * from "./KeyFinanceRatioPdf.vue?vue&type=script&lang=js"
import style0 from "./KeyFinanceRatioPdf.vue?vue&type=style&index=0&id=2aff87ff&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aff87ff",
  null
  
)

export default component.exports